import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import axios from 'axios'//引入axios
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.prototype.$axios = axios;//把axios挂载到vue上
Vue.use(ElementUI);
Vue.use(dataV)
Vue.config.productionTip = false

axios.defaults.timeout = 50000;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

//axios.defaults.baseURL = 'http://121.36.24.242:7080/';
axios.defaults.baseURL = 'https://121.36.24.242:5200/';
new Vue({
  render: h => h(App),
}).$mount('#app')
